import createLucideIcon from '../createLucideIcon';

const Twitch = createLucideIcon('TwitchIcon', [
  ['path', { d: 'M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7', key: 'c0yzno' }],
]);

export default Twitch;
